import { Area } from '@/shared/model/enumerations/area';
export interface IFiltroPrograma {
  tipoEspecial?: string | null;
  programaEstatus?: string | null;
  programaId?: string | null;
  clave?: string | null;
  coordinadorCvu?: string | null;
  coordinadorLogin?: string | null;
  claveInstitucion?: string | null;
  cveModalidad?: string | null;
  area?: Area;
  cveGrado?: string | null;
  tengaInstitucion?: boolean;
}

export class FiltroPrograma implements IFiltroPrograma {
  constructor(
    public tipoEspecial?: string | null,
    public programaEstatus?: string | null,
    public programaId?: string | null,
    public clave?: string | null,
    public coordinadorCvu?: string | null,
    public asistenteCvu?: string | null,
    public coordinadorLogin?: string | null,
    public claveInstitucion?: string | null,
    public nombrePrograma?: string | null,
    public nombreInstitucion?: string | null,
    public clavesProgramas?: string[] | null,
    public cveModalidad?: string | null,
    public area?: Area,
    public cveGrado?: string | null,
    public tengaInstitucion?: boolean | null
  ) {}
}
